import Column from './Column';

const Row = ({columns}) => {
    return <div className="row">
        {columns.map((col, i) => <Column key={i} {...col} />)}
    </div>;
}

export default Row;